import * as React from "react";
import BookingModal from "./booking-modal";
import { FormattedMessage } from "react-intl";

const StickyBookingBar = ({
  destination,
  duration,
  price,
  urlFillout,
  ctaLabel,
}) => {
  const bookingModalTriggerRef = React.useRef(null);
  const [isVisible, setIsVisible] = React.useState(false);
  const [isBookingModalOpen, setIsBookingModalOpen] = React.useState(false);
  const openBookingModal = () => setIsBookingModalOpen(true);
  const closeBookingModal = () => setIsBookingModalOpen(false);

  React.useEffect(() => {
    const handleScroll = () => {
      const bookingSection = document.getElementById("booking-widget");
      if (bookingSection) {
        const rect = bookingSection.getBoundingClientRect();
        setIsVisible(rect.bottom <= 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    isVisible && (
      <>
        <div className="sticky-booking-bar">
          <div className="sticky-booking-bar-content">
            <p className="sticky-booking-bar-intro">
              <span className="destination">{destination}</span> -
              <span className="duration"> {duration}</span>
            </p>
            <div>
              <p>
                <FormattedMessage id="from" /> :
                <span className="price"> {price}€</span>
              </p>
              <button onClick={openBookingModal} ref={bookingModalTriggerRef}>
                {ctaLabel ? ctaLabel : <FormattedMessage id="viewDepartures" />}
              </button>
            </div>
          </div>
          <BookingModal
            isOpen={isBookingModalOpen}
            onClose={closeBookingModal}
            urlFillout={urlFillout}
            destination={destination.title}
            triggerRef={bookingModalTriggerRef}
          />
        </div>
      </>
    )
  );
};

export default StickyBookingBar;
